import { createActions } from "reduxsauce";

const { Types } = createActions({
	wizardReset: [],
	updateActivity: ['currentTime'],
	setLanguage: ['lang']
});

export const CommonTypes = Types;
